import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import messages from '../../messages'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  listIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  heading: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightRegular,
    margin: theme.spacing(0, 0, 4, 1),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
  },
}))

interface SubTotalProps {
  count?: number | null
  price?: string | null
}

const SubTotal: React.FC<SubTotalProps> = ({ count, price }) => {
  const classes = useStyles()

  return (
    <Box mt={18}>
      <h3 className={classes.heading}>
        <FormattedMessage {...messages.SEMICONF_SUBTOTAL_KICQSTART} />
      </h3>
      <Grid container alignItems="flex-end" justify="center">
        <Grid item sm={1} className={classes.listIcon}>
          <img alt="hexes" src="/static/hexes.png" />
        </Grid>
        <Grid item sm={7}>
          <p className={classes.labelRoot}>
            <FormattedMessage
              {...messages.SEMICONF_OLIGOS_SELECTED_KICQSTART}
            />
            {count}
          </p>
        </Grid>
        <Grid item sm={4}>
          <p className={classes.labelRoot}>{price}</p>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubTotal
